import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isFunction } from "lodash";

import {
  createMeterUploadDraft,
  type CreateDraftInput,
  type MeterUploadDraft,
} from "@services/bulkMeterUpload";

export const useCreateMeterUploadDraft = ({
  onSuccess,
  ...options
}: Record<string, any> = {}) => {
  const queryClient = useQueryClient();
  return useMutation((input: CreateDraftInput) => createMeterUploadDraft(input), {
    ...options,
    onSuccess: (draft: MeterUploadDraft) => {
      queryClient.invalidateQueries({
        queryKey: ["meterUploads", draft.level1ResourceId],
      });
      if (isFunction(onSuccess)) onSuccess(draft);
    },
  });
};
